// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/ids.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file vitesse/v1/ids.proto.
 */
export const file_vitesse_v1_ids = /*@__PURE__*/ fileDesc("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");
/**
 * Describes the message vitesse.v1.IdsDescriptor.
 * Use `create(IdsDescriptorSchema)` to create a new message.
 */
export const IdsDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_ids, 0);
/**
 * Describes the message vitesse.v1.IdsStats.
 * Use `create(IdsStatsSchema)` to create a new message.
 */
export const IdsStatsSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_ids, 1);
/**
 * Describes the message vitesse.v1.SignatureCount.
 * Use `create(SignatureCountSchema)` to create a new message.
 */
export const SignatureCountSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_ids, 2);
/**
 * Describes the message vitesse.v1.CategoryCount.
 * Use `create(CategoryCountSchema)` to create a new message.
 */
export const CategoryCountSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_ids, 3);
/**
 * Describes the message vitesse.v1.SourceCount.
 * Use `create(SourceCountSchema)` to create a new message.
 */
export const SourceCountSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_ids, 4);
/**
 * Describes the message vitesse.v1.ActiveBlock.
 * Use `create(ActiveBlockSchema)` to create a new message.
 */
export const ActiveBlockSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_ids, 5);
/**
 * Describes the message vitesse.v1.IdsAlert.
 * Use `create(IdsAlertSchema)` to create a new message.
 */
export const IdsAlertSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_ids, 6);
/**
 * Describes the message vitesse.v1.IdsBlockEvent.
 * Use `create(IdsBlockEventSchema)` to create a new message.
 */
export const IdsBlockEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_ids, 7);
/**
 * @generated from enum vitesse.v1.IdsMode
 */
export var IdsMode;
(function (IdsMode) {
    /**
     * @generated from enum value: IDS_MODE_UNSPECIFIED = 0;
     */
    IdsMode[IdsMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: IDS_MODE_OFF = 1;
     */
    IdsMode[IdsMode["OFF"] = 1] = "OFF";
    /**
     * @generated from enum value: IDS_MODE_MONITOR = 2;
     */
    IdsMode[IdsMode["MONITOR"] = 2] = "MONITOR";
    /**
     * @generated from enum value: IDS_MODE_PROTECT = 3;
     */
    IdsMode[IdsMode["PROTECT"] = 3] = "PROTECT";
})(IdsMode || (IdsMode = {}));
/**
 * Describes the enum vitesse.v1.IdsMode.
 */
export const IdsModeSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_ids, 0);
/**
 * @generated from enum vitesse.v1.IdsStatus
 */
export var IdsStatus;
(function (IdsStatus) {
    /**
     * @generated from enum value: IDS_STATUS_UNSPECIFIED = 0;
     */
    IdsStatus[IdsStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: IDS_STATUS_STARTING = 1;
     */
    IdsStatus[IdsStatus["STARTING"] = 1] = "STARTING";
    /**
     * @generated from enum value: IDS_STATUS_RUNNING = 2;
     */
    IdsStatus[IdsStatus["RUNNING"] = 2] = "RUNNING";
    /**
     * @generated from enum value: IDS_STATUS_DEGRADED = 3;
     */
    IdsStatus[IdsStatus["DEGRADED"] = 3] = "DEGRADED";
    /**
     * @generated from enum value: IDS_STATUS_ERROR = 4;
     */
    IdsStatus[IdsStatus["ERROR"] = 4] = "ERROR";
})(IdsStatus || (IdsStatus = {}));
/**
 * Describes the enum vitesse.v1.IdsStatus.
 */
export const IdsStatusSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_ids, 1);
/**
 * @generated from enum vitesse.v1.Interface
 */
export var Interface;
(function (Interface) {
    /**
     * @generated from enum value: INTERFACE_UNSPECIFIED = 0;
     */
    Interface[Interface["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: INTERFACE_IT = 1;
     */
    Interface[Interface["IT"] = 1] = "IT";
    /**
     * @generated from enum value: INTERFACE_OT = 2;
     */
    Interface[Interface["OT"] = 2] = "OT";
})(Interface || (Interface = {}));
/**
 * Describes the enum vitesse.v1.Interface.
 */
export const InterfaceSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_ids, 2);
/**
 * @generated from enum vitesse.v1.AlertSeverity
 */
export var AlertSeverity;
(function (AlertSeverity) {
    /**
     * @generated from enum value: ALERT_SEVERITY_UNSPECIFIED = 0;
     */
    AlertSeverity[AlertSeverity["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ALERT_SEVERITY_INFO = 1;
     */
    AlertSeverity[AlertSeverity["INFO"] = 1] = "INFO";
    /**
     * @generated from enum value: ALERT_SEVERITY_LOW = 2;
     */
    AlertSeverity[AlertSeverity["LOW"] = 2] = "LOW";
    /**
     * @generated from enum value: ALERT_SEVERITY_MEDIUM = 3;
     */
    AlertSeverity[AlertSeverity["MEDIUM"] = 3] = "MEDIUM";
    /**
     * @generated from enum value: ALERT_SEVERITY_HIGH = 4;
     */
    AlertSeverity[AlertSeverity["HIGH"] = 4] = "HIGH";
    /**
     * @generated from enum value: ALERT_SEVERITY_CRITICAL = 5;
     */
    AlertSeverity[AlertSeverity["CRITICAL"] = 5] = "CRITICAL";
})(AlertSeverity || (AlertSeverity = {}));
/**
 * Describes the enum vitesse.v1.AlertSeverity.
 */
export const AlertSeveritySchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_ids, 3);
/**
 * @generated from enum vitesse.v1.BlockReason
 */
export var BlockReason;
(function (BlockReason) {
    /**
     * @generated from enum value: BLOCK_REASON_UNSPECIFIED = 0;
     */
    BlockReason[BlockReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: BLOCK_REASON_AUTO = 1;
     */
    BlockReason[BlockReason["AUTO"] = 1] = "AUTO";
    /**
     * @generated from enum value: BLOCK_REASON_MANUAL = 2;
     */
    BlockReason[BlockReason["MANUAL"] = 2] = "MANUAL";
})(BlockReason || (BlockReason = {}));
/**
 * Describes the enum vitesse.v1.BlockReason.
 */
export const BlockReasonSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_ids, 4);
//# sourceMappingURL=ids_pb.js.map